/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eg_Redefining_Digital_ExcellInputs */

const en_eg_redefining_digital_excell = /** @type {(inputs: Eg_Redefining_Digital_ExcellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Redefining digital excellence.`)
};

const es_eg_redefining_digital_excell = /** @type {(inputs: Eg_Redefining_Digital_ExcellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ej. Redefiniendo la excelencia digital.`)
};

const fr_eg_redefining_digital_excell = /** @type {(inputs: Eg_Redefining_Digital_ExcellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. Redéfinir l'excellence numérique.`)
};

const de_eg_redefining_digital_excell = /** @type {(inputs: Eg_Redefining_Digital_ExcellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. Digitale Exzellenz neu definieren.`)
};

const ja_eg_redefining_digital_excell = /** @type {(inputs: Eg_Redefining_Digital_ExcellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例: デジタルの卓越性を再定義する。`)
};

const zh_eg_redefining_digital_excell = /** @type {(inputs: Eg_Redefining_Digital_ExcellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例如：重新定义数字卓越体验。`)
};

const ar_eg_redefining_digital_excell = /** @type {(inputs: Eg_Redefining_Digital_ExcellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مثال: إعادة تعريف التميز الرقمي.`)
};

const id_eg_redefining_digital_excell = /** @type {(inputs: Eg_Redefining_Digital_ExcellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mis. Mendefinisikan ulang keunggulan digital.`)
};

const it_eg_redefining_digital_excell = /** @type {(inputs: Eg_Redefining_Digital_ExcellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`es. Ridefiniamo l'eccellenza digitale.`)
};

const ru_eg_redefining_digital_excell = /** @type {(inputs: Eg_Redefining_Digital_ExcellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`например, Переосмысляем цифровое совершенство.`)
};

const pt_eg_redefining_digital_excell = /** @type {(inputs: Eg_Redefining_Digital_ExcellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. Redefinindo a excelência digital.`)
};

const ko_eg_redefining_digital_excell = /** @type {(inputs: Eg_Redefining_Digital_ExcellInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`예: 디지털의 우수성을 재정의합니다.`)
};

/**
* | output |
* | --- |
* | "e.g. Redefining digital excellence." |
*
* @param {Eg_Redefining_Digital_ExcellInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const eg_redefining_digital_excell = /** @type {((inputs?: Eg_Redefining_Digital_ExcellInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eg_Redefining_Digital_ExcellInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eg_redefining_digital_excell(inputs)
	if (locale === "es") return es_eg_redefining_digital_excell(inputs)
	if (locale === "fr") return fr_eg_redefining_digital_excell(inputs)
	if (locale === "de") return de_eg_redefining_digital_excell(inputs)
	if (locale === "ja") return ja_eg_redefining_digital_excell(inputs)
	if (locale === "zh") return zh_eg_redefining_digital_excell(inputs)
	if (locale === "ar") return ar_eg_redefining_digital_excell(inputs)
	if (locale === "id") return id_eg_redefining_digital_excell(inputs)
	if (locale === "it") return it_eg_redefining_digital_excell(inputs)
	if (locale === "ru") return ru_eg_redefining_digital_excell(inputs)
	if (locale === "pt") return pt_eg_redefining_digital_excell(inputs)
	return ko_eg_redefining_digital_excell(inputs)
});